import type { Availability } from "@/domain/catalog/catalog-product";

export interface AvailabilityLabelProps {
  readonly availability: Availability;
  readonly className?: string;
  readonly variant?: "text" | "badge";
}

const availabilityLabels: Record<Availability, string> = {
  available: "Stock disponible",
  check_stock: "Consultar stock",
  out_of_stock: "Sin stock",
  coming_soon: "Sin Stock",
};

export function AvailabilityLabel({
  availability,
  className = "text-sm",
  variant = "text",
}: Readonly<AvailabilityLabelProps>) {
  const isOutOfStockBadge = availability === "out_of_stock" && variant === "badge";
  const colorClass =
    availability === "available"
      ? "text-secondary"
      : availability === "check_stock"
        ? "text-accent-orange"
        : "text-red-600";
  const presentationClass = isOutOfStockBadge
    ? "flex min-h-7 w-full items-center justify-center rounded-md bg-red-600 px-1.5 text-center text-white"
    : colorClass;

  return (
    <span className={`${className} font-extrabold ${presentationClass}`}>
      {availabilityLabels[availability]}
    </span>
  );
}
